module.exports = __webpack_public_path__ + "img/tab-8.2176f40b.png";